import { ChangeDetectorRef, Directive, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractState } from '../abstract/abstract.state';

@Directive({
  selector: '[sasUpdateOnChange]'
})
export class UpdateOnChangeDirective implements OnDestroy {
  private sub?: Subscription;

  @Input('sasUpdateOnChange') set state(state: AbstractState<any>) {
    this.sub = state.state$.subscribe();
    this.cdr.markForCheck();
  }

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
